<template>
  <div>
    <div class="container faq">
      <h1 class="faq__title">Частые вопросы</h1>
    </div>
    <div class="container">
      <div class="content">
        <aside class="content__col">
          <nav class="faq-nav">
            <a href="#faq-01" class="faq-nav__item">Зачем умный дом в обычной квартире?</a>
            <a href="#faq-02" class="faq-nav__item">Где можно установить эту систему?</a>
            <a href="#faq-03" class="faq-nav__item">Что входит в стоимость?</a>
            <a href="#faq-04" class="faq-nav__item">Сколько времени занимает установка?</a>
            <a href="#faq-05" class="faq-nav__item">Защищена ли система от взлома?</a>
            <a href="#faq-06" class="faq-nav__item">Какая этапность проведения работ?</a>
            <a href="#faq-07" class="faq-nav__item">А если я не разберусь, как она работает?</a>
            <a href="#faq-08" class="faq-nav__item">В каких городах работает сервис?</a>
            <a href="#faq-09" class="faq-nav__item">Не испортит ли система интерьер?</a>
          </nav>
        </aside>
        <article class="content__col content__col_main">
          <div class="faq-list">
            <div class="faq-list__item" id="faq-01">
              <h4 class="faq-list__title">Зачем умный дом в обычной квартире?</h4>
              <p class="faq-list__descript">Умный дом&nbsp;— не&nbsp;технологическая диковинка, а&nbsp;новая норма жизни. Благодаря системе автоматизации домашних дел квартира потребляет меньше энергоресурсов. Видеонаблюдение помогает присматривать за&nbsp;детьми и&nbsp;сохранностью квартиры. А&nbsp;уж&nbsp;как удивятся ваши друзья, когда вы&nbsp;одной волшебной фразой «Siri, киносеанс» закроете шторы, приглушите свет и&nbsp;включите мультимедийную систему. Каждый год появляются всё новые устройства на&nbsp;платформе Homekit&nbsp;— это значит, что ваш умный дом в&nbsp;будущем может ещё прибавить в&nbsp;уме.</p>
            </div>
            <div class="faq-list__item" id="faq-02">
              <h4 class="faq-list__title">Где можно установить эту систему?</h4>
              <p class="faq-list__descript">Умный дом работает в&nbsp;любом типе жилища&nbsp;— квартире, таунхаусе, загородном коттедже. Стандартные решения позволяют создавать единую сеть для домов площадью до&nbsp;500&nbsp;м² и&nbsp;высотой не&nbsp;более 5&nbsp;этажей&nbsp;— офисы, мини-отели и&nbsp;кафе вполне подойдут. Если ваше помещение обладает большей площадью или этажностью, позвоните нам&nbsp;— мы&nbsp;разработаем технический проект с&nbsp;использованием другого оборудования.</p>
            </div>
            <div class="faq-list__item" id="faq-03">
              <h4 class="faq-list__title">Что входит в стоимость?</h4>
              <p class="faq-list__descript">Каждый проект индивидуален и&nbsp;разрабатывается с&nbsp;учётом ваших потребностей и&nbsp;особенностей жилища. В&nbsp;стоимость услуги входят: выезд специалиста для составления спецификации системы, монтаж и&nbsp;подключение оборудования, настройка работы отдельных компонетов и&nbsp;объединение их&nbsp;в&nbsp;единую систему, настройка индивидуальных сценариев работы, обучение работы с&nbsp;системой и&nbsp;годовая удаленная поддержка.</p>
            </div>
            <div class="faq-list__item" id="faq-04">
              <h4 class="faq-list__title">Сколько времени занимает установка?</h4>
              <p class="faq-list__descript">Монтаж занимает не&nbsp;более 14&nbsp;дней, если соблюдены следующие требования:</p>
              <ul class="list">
                <li class="list__item">В&nbsp;помещении завершена чистовая отделка, не&nbsp;проводится других работ, мешающих установке.</li>
                <li class="list__item">Заказчик или доверенное лицо присутствует на&nbsp;объекте во&nbsp;время установки.</li>
                <li class="list__item">Помещение обеспечено канализацией, энергоснабжением (220&nbsp;В) и&nbsp;водоснабжением.</li>
                <li class="list__item">В&nbsp;помещении держится постоянная температура не&nbsp;ниже +18°&nbsp;и&nbsp;не&nbsp;выше&nbsp;+30°</li>
                <li class="list__item">К&nbsp;точке установки подведено питание для всех компонентов, работающих на&nbsp;постоянном питании, подрозетники в&nbsp;точках установки глубиной 60&nbsp;мм или больше.</li>
                <li class="list__item">Обеспечен беспрепятственный доступ к&nbsp;электрощитам, позволяющим обесточивать линии нагрузки, на&nbsp;которых подключается оборудование.</li>
                <li class="list__item">Имеется беспрепятственный доступ ко&nbsp;всем точкам установки компонентов системы.</li>
              </ul>
            </div>
            <div class="faq-list__item" id="faq-05">
              <h4 class="faq-list__title">Защищена&nbsp;ли система от&nbsp;взлома?</h4>
              <p class="faq-list__descript">Настройтесь на&nbsp;здоровый сон. Защищенность системы соответствует высоким промышленным требованиям&nbsp;— каждое устройство работает по&nbsp;фреймворку безопасности Security&nbsp;2 (S2). Он&nbsp;включает в&nbsp;себя шифрование AES 128&nbsp;с усовершенствованной функцией обмена ключами с&nbsp;использованием симметричного шифрования Диффи-Хеллмана (ECDH) и&nbsp;проверкой подлинности данных, предотвращающих попытку взлома. Если говорить простым языком&nbsp;— хакеры останутся не&nbsp;у&nbsp;дел.</p>
            </div>
            <div class="faq-list__item" id="faq-06">
              <h4 class="faq-list__title">Какая этапность проведения работ?</h4>
              <p class="faq-list__descript">Сначала технический специалист выезжает на&nbsp;объект. Затем он&nbsp;составляет техническое задание с&nbsp;учётом ваших пожеланий и&nbsp;особенностей жилища. После этого вы&nbsp;согласуете спецификацию и&nbsp;определите удобную дату подписания договора. Затем мы&nbsp;установим систему, настроим&nbsp;её, научим вас ей&nbsp;пользоваться&nbsp;— останется только подписаться акт о&nbsp;выполненных работах.</p>
            </div>
            <div class="faq-list__item" id="faq-07">
              <h4 class="faq-list__title">А если я не разберусь, как она работает?</h4>
              <p class="faq-list__descript">Наши специалисты настроят систему специально под вас и&nbsp;подробно объяснят, как она работает. Управлять умным домом можно с&nbsp;помощью голосовых команда Siri или с&nbsp;предустановленного приложения «Дом». Разобраться с&nbsp;этим сможет любой&nbsp;— от&nbsp;дошкольника до&nbsp;пенсионера.</p>
            </div>
            <div class="faq-list__item" id="faq-08">
              <h4 class="faq-list__title">В каких городах работает сервис?</h4>
              <p class="faq-list__descript">Пока мы&nbsp;работаем только в Санкт-Петербурге и ЛО.</p>
            </div>
            <div class="faq-list__item" id="faq-09">
              <h4 class="faq-list__title">Не испортит ли система интерьер?</h4>
              <p class="faq-list__descript">Все датчики беспроводные, выпускаются в&nbsp;различных цветовых решения, поэтому система органично впишется в&nbsp;любой интерьер.</p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    var firstScroll = 63;
    $('.faq-nav__item').on('click', function(e) {
      $('aside, .title').css({ 'position': 'fixed' });
      $('.title').css('margin-top', '-55px');
      $('article').css('margin-left', '300px');
      e.preventDefault();
      var id = $(this).attr('href');
      var $item = $(id);

      if ($item) {
        $('html, body').animate({
          scrollTop: $item.offset().top - 76 - firstScroll
        }, 400);
        setTimeout(() => firstScroll = 0, 410);
      }
    });
    $(window).scroll(function() {
      if (scrollY > 1500) {
        $('aside, .title').css({ 'position': 'static' });
        $('.title').css('margin-top', 0);
        $('article').css('margin-left', 0);
      }
    });
  }
}
</script>
<style scoped lang="scss">
.faq {
  &-nav {
    position: fixed;
    &__item {
      display: block;
      color: #ff208a;
      font-size: 14px;
      line-height: 21px;
      margin-top: 10px;

      &:nth-child(1) {
        margin-top: 0;
      }
    }
  }

  &__title {
    font: 24px/32px "Graphik-Medium-Cy", sans-serif;
    margin: -70px 0;
    text-align: left;
    position: fixed;
  }

  &-list {
    margin-bottom: 350px;

    &__item {
      margin-top: 28px;

      &:first-of-type {
        margin-top: 0;
      }

      .list {
        margin-top: 10px;
      }

      .list__item {
        margin-top: 10px;
      }
    }

    &__title {
      font: 18px/20px "Graphik-Medium-Cy", sans-serif;
    }

    &__descript {
      font-size: 14px;
      line-height: 21px;
      margin-top: 11px;
      margin-bottom: 0;
    }
  }
}
@media screen and (max-width: 767px) {
  .content {
    flex-direction: column;
    &__col {
      &_main {
        width: 100%;
        margin: 30px -15px;
      }
    }
  }
  aside {
    width: 100%;
  }
  .faq {
    &-nav {
      position: static;
      width: 100%;
    }
    &-list {
      width: 100%;
      margin-bottom: 0;
    }
  }
}
</style>